import { computed, defineComponent, onBeforeUnmount, onMounted, ref, } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { localizedTo } from '@/composables/useLocalizedRoute';
export default defineComponent({
    name: 'Navbar',
    setup() {
        const { t, locale } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const langOptions = [
            { code: 'en', label: 'EN' },
            { code: 'pl', label: 'PL' },
            { code: 'de', label: 'DE' },
            { code: 'it', label: 'IT' },
        ];
        const langOpen = ref(false);
        const langRoot = ref(null);
        const toggleLang = () => {
            langOpen.value = !langOpen.value;
        };
        const pickLang = (code) => {
            langOpen.value = false;
            // Re-push the current named route with the new locale prefix.
            const name = route.name || 'home';
            const params = { ...route.params };
            delete params.lang;
            router.push({
                name,
                params: code === 'en' ? params : { ...params, lang: code },
                hash: route.hash,
            });
        };
        const portfolioOpen = ref(false);
        const portfolioRoot = ref(null);
        const portfolioOptions = computed(() => [
            { value: 'hotels', label: t('portfolio.categoryLabels.hotels') },
            { value: 'tourism', label: t('portfolio.categoryLabels.tourism') },
            { value: 'products', label: t('portfolio.categoryLabels.products') },
        ]);
        const openPortfolio = () => { portfolioOpen.value = true; };
        const closePortfolio = () => { portfolioOpen.value = false; };
        const onDocClick = (e) => {
            if (langOpen.value && langRoot.value && !langRoot.value.contains(e.target)) {
                langOpen.value = false;
            }
            if (portfolioOpen.value && portfolioRoot.value && !portfolioRoot.value.contains(e.target)) {
                portfolioOpen.value = false;
            }
        };
        const onEsc = (e) => {
            if (e.key !== 'Escape')
                return;
            langOpen.value = false;
            portfolioOpen.value = false;
        };
        onMounted(() => {
            document.addEventListener('click', onDocClick);
            document.addEventListener('keydown', onEsc);
        });
        onBeforeUnmount(() => {
            document.removeEventListener('click', onDocClick);
            document.removeEventListener('keydown', onEsc);
        });
        return {
            locale,
            langOptions,
            langOpen,
            langRoot,
            toggleLang,
            pickLang,
            portfolioOpen,
            portfolioRoot,
            portfolioOptions,
            openPortfolio,
            closePortfolio,
            localizedTo,
        };
    },
});
